import { Injectable } from '@angular/core';
import { ResourceAction, ResourceParams, ResourceRequestMethod, IResourceMethod } from '@ngx-resource/core';
import { RestClient } from './rest.client';
import { environment } from '../../environments/environment';
import { Header } from '../interfaces/IHeader';

interface Address {
    data: any;
}

@Injectable()
@ResourceParams({
    url: `${environment.url.api}`,
    pathPrefix: '/api'
})
export class LocationService extends RestClient {

    @ResourceAction({
        path: '/states',
        noAuth: true,
        isArray: true
    })
    getStates: IResourceMethod<{}, Address>;

    @ResourceAction({
        path: '/countries',
        noAuth: true,
        isArray: true
    })
    getCountries: IResourceMethod<{}, Address>;

    @ResourceAction({
        path: '/regions',
        noAuth: true,
        isArray: true
    })
    getRegions: IResourceMethod<{}, Address>;

    @ResourceAction({
        path: '/languages/{:formId}',
        noAuth: false,
        method: ResourceRequestMethod.Get,
        isArray: true
    })
    getLanguages: IResourceMethod<{formId:any}, Header>;

    @ResourceAction({
    path: '/languages/change/{:languageId}',
        noAuth: false,
        method: ResourceRequestMethod.Post,
        isArray: true
    })
    setSecUserLanguage: IResourceMethod<{languageId:any}, Header>;

}
